// Timezone detection and syncing component
import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import supabase from '../../utils/supabase';

const TimezoneSync = () => {
  const { user, userProfile } = useAuth();
  
  useEffect(() => {
    // Only run if user is logged in and doesn't have a timezone set
    if (user?.id && userProfile && !userProfile.timezone) {
      const syncTimezone = async () => {
        try {
          // Detect user's timezone using Intl API
          const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          
          if (timezone) {
            // Update user profile with detected timezone
            await supabase
              .from('user_profiles')
              .update({ 
                timezone,
                updated_at: new Date().toISOString()
              })
              .eq('id', user.id);
              
            if (process.env.NODE_ENV === 'development') {
              console.log('Timezone synchronized:', timezone);
            }
          }
        } catch (error) {
          console.error('Failed to sync timezone:', error);
        }
      };
      
      syncTimezone();
    }
  }, [user?.id, userProfile]);
  
  // This is a utility component that doesn't render anything
  return null;
};

export default TimezoneSync;

